<template>
  <div>
    <or-layout>
      <h3 class="page">
        相似题
        <a-button type="primary" icon="left" @click="goPage">返回</a-button>
      </h3>

      <div class="main">
        <a-row class="row" :gutter="16" v-if="mission_info">
          <a-col :span="16">
            <h2 class="title">{{ mission_info.name }}</h2>
            <div class="row">类型:{{ mission_info.typename }}</div>
          </a-col>
        </a-row>
        <a-tabs class="row" type="card" :activeKey="currTabKey" @change="tabsChange">
          <a-tab-pane tab="相似任务" key="tasks">
            <a-table :dataSource="squadMissionList" :rowKey="item => item.start_time + item.end_time" :pagination="false"
              bordered>
              <a-table-column key="name" title="任务名字" data-index="name" />
              <a-table-column key="nickname" title="学生名字" data-index="nickname" />
              <a-table-column key="start_time" title="时间" data-index="start_time">
                <template slot-scope="text, item">
                  <range-picker :start-time="item.start_time" :end-time="item.end_time"
                    @change="editMissionTime(item, $event)" />
                </template>
              </a-table-column>
              <a-table-column key="active" width="280px" title="操作">
                <template slot-scope="item">
                  <a-button @click="delSimilar(item.similar_mission_id)" class="active_btn" size="small" type="link">删除任务
                  </a-button>
                  <view-exam-modal :item="{ id: item.examination_id }" />
                </template>
              </a-table-column>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="设置" key="settings">
            <a-button @click="makeSimilarMission" type="primary">生成相似题任务</a-button>
          </a-tab-pane>
        </a-tabs>
      </div>
    </or-layout>
  </div>
</template>


<script>
import RangePicker from "@/components/range-picker";
import ViewExamModal from '@/components/question/view-exam-modal.vue'
import moment from "moment";

export default {
  components: { "range-picker": RangePicker, ViewExamModal },
  data() {
    return {
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      squad_id: undefined,
      mission_info: undefined,
      mission_id: undefined,
      squadMissionList: [],
      currTabKey: "tasks"
    }
  },
  mounted() {
    this.squad_id = this.$route.query.squad_id;
    this.mission_id = this.$route.query.mission_id;
    this.getmissioninfo();
    this.getsimilarlistbymission();
  },

  methods: {
    getmissioninfo() {
      this.$axios
        .post("/api/BasicMission/getmissioninfo", {
          data: { id: this.mission_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.mission_info = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getsimilarlistbymission() {
      this.$axios
        .post("/api/BasicMission/getsimilarlistbymission", {
          data: { mission_id: this.mission_id, squad_id: this.squad_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadMissionList = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    makeSimilarMission() {
      this.$axios
        .post("/api/BasicMission/createsimilarbysquad", {
          data: { mission_id: this.mission_id, squad_id: this.squad_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.$success({
              title: "正确",
              content: "相似任务生成完毕",
              okText: "确定"
            });
            this.tabsChange('tasks');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
    },
    tabsChange(key) {
      this.currTabKey = key;
      this.pageinfo.current = 1;
      switch (key) {
        case "tasks":
          this.getsimilarlistbymission();
          break;
        case "settings":
          break;
        default:
          break;
      }
    },
    goPage() {
      this.$router.push('/orgquadinfo?id=' + this.squad_id);
    },
    editMissionTime(item, range) {
      let data = {
        mission_id: item.id,
        squad_id: this.squad_id,
        start_time: parseInt(range[0].valueOf() / 1000),
        end_time: parseInt(range[1].valueOf() / 1000)
      };
      this.$axios
        .post("/api/OrgSquad/editsquadmission", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getsimilarlistbymission();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    delSimilar(id) {
      this.$axios
        .post("/api/BasicMission/delsimilarlmission", {
          data: { id: id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getsimilarlistbymission();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    moment
  }
};
</script>


<style lang="less" scoped>
.main {
  margin-top: 1.5rem;
}

.row {
  margin-top: 1rem;
}

.title {
  font-weight: 700;
  font-family: 微软雅黑, tahoma;
}

.page {
  display: flex;
  justify-content: space-between;
}
</style>